import api from '@/utils/api'

export default {
    uploadPhoto(uploadPath, formData) {
        return api.uploadImage(`uploads/images/${uploadPath}`, formData)
    },
    uploadFile(uploadPath, formData) {
        return api.uploadFile(`uploads/files/${uploadPath}`, formData)
    }
}
